import { RoadSectionFilter, RoadSectionSort } from '../core/domain/Reference';
import { ExternalReferenceConfigurationPort } from '../core/reference/ExternalReferenceConfigurationPort';

const REFERENCE_PREFIX = 'reference';
export class ExternalReferenceConfigurationProvider implements ExternalReferenceConfigurationPort {
    private readonly sortKey = `${REFERENCE_PREFIX}-sort`;
    private readonly filterKey = `${REFERENCE_PREFIX}-filter`;
    saveRoadSectionsSort(sort: RoadSectionSort): void {
        localStorage.setItem(this.sortKey, JSON.stringify(sort));
    }
    loadRoadSectionsSort(): RoadSectionSort {
        const storedSort = localStorage.getItem(this.sortKey);

        return storedSort ? JSON.parse(storedSort) : [];
    }
    saveRoadSectionsFilter(filter: RoadSectionFilter): void {
        localStorage.setItem(this.filterKey, JSON.stringify(filter));
    }
    loadRoadSectionsFilter(): RoadSectionFilter {
        const storedFilter = localStorage.getItem(this.filterKey);

        return storedFilter ? JSON.parse(storedFilter) : { items: [] };
    }
    saveRoadSectionId(roadSectionId: string): void {
        localStorage.setItem(`${REFERENCE_PREFIX}-road-section-id`, roadSectionId);
    }
    loadRoadSectionId(): string | null {
        const roadSectionId = localStorage.getItem(`${REFERENCE_PREFIX}-road-section-id`);

        return roadSectionId ?? null;
    }

    saveColumnVisibility(userId: string, model: Record<string, boolean>): void {
        localStorage.setItem(`${REFERENCE_PREFIX}-columns-${userId}`, JSON.stringify(model));
    }

    loadColumnVisibility(userId: string): Record<string, boolean> {
        const stored = localStorage.getItem(`${REFERENCE_PREFIX}-columns-${userId}`);

        return stored ? JSON.parse(stored) : {};
    }
}
